import { Link } from "react-router-dom";

import { sectionById } from "@/lib/sections";
import { ProjectShelf } from "./ProjectShelf";
import { SectionHeader } from "./SectionHeader";

export function ProjectsSection() {
  const section = sectionById("projects")!;

  return (
    <section id="projects" className="shell py-16 sm:py-20 md:py-24">
      <SectionHeader section={section} kicker="Things the club has built." />

      <ProjectShelf />

      {/* One link for the section, not one per project. Each card already
          carries its own call to action; repeating this beside every one of
          them made the shelf read as a wall of near-identical buttons. */}
      <div className="mt-12 border-t-2 border-ink pt-8">
        <Link to="/projects" className="btn btn--ghost">
          View projects
        </Link>
      </div>
    </section>
  );
}
